import { createSelector } from 'reselect';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import {
  checkBusinessEligibility,
  resetBusinessValidationResult,
  verifyInvitation,
} from './actions';
import { selectBusinessValidationResult, selectMainPortal } from '../../../selectors';
import abnSearchApi from '../../../api/abnSearchApi';

// eslint-disable-next-line import/no-cycle
import { gotoNextStep } from '../steps/actions';
import BusinessDetails from './Component';

const mapStateToProps = createSelector(
  selectBusinessValidationResult,
  selectMainPortal,
  (validationResult, portal) => ({
    validationResult,
    portal,
  }),
);

function mapDispatchToProps(dispatch) {
  return {
    isEligible: (abn, isTrustee) => dispatch(checkBusinessEligibility(abn, isTrustee)),
    resetValidationResult: () => dispatch(resetBusinessValidationResult()),
    continueToNextStep: () => dispatch(gotoNextStep()),
    searchAbn: (keyword) => abnSearchApi.searchAbn(keyword),
    verifyInvitation: (portal, recipientGcContactId) =>
      dispatch(verifyInvitation(portal, recipientGcContactId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessDetails);
